import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatOptionModule } from '@angular/material/core';
import { MatSelectModule } from '@angular/material/select';
import { MatIconModule } from '@angular/material/icon';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatButtonModule } from '@angular/material/button';
import { MatMenuModule } from '@angular/material/menu';
import { MatDialogModule } from '@angular/material/dialog';
import { ChartsModule } from '@progress/kendo-angular-charts';
import { MatTooltipModule } from "@angular/material/tooltip"
import { GridModule } from '@progress/kendo-angular-grid';
import { ButtonsModule } from '@progress/kendo-angular-buttons';
import { DateInputsModule } from '@progress/kendo-angular-dateinputs';
import { GaugesModule} from '@progress/kendo-angular-gauges';
import { MaxisChartComponent } from './maxis-chart/maxis-chart.component';
import { MaxisChartModalComponent } from './maxis-chart-modal/maxis-chart-modal.component';

@NgModule({
  declarations: [MaxisChartComponent, MaxisChartModalComponent],
  imports: [
    CommonModule,
    MatFormFieldModule,
    MatOptionModule, MatSelectModule,
    ChartsModule, MatIconModule, MatTooltipModule,
    MatProgressSpinnerModule, GaugesModule, MatDialogModule,
    MatButtonModule, MatMenuModule, GridModule, ButtonsModule, DateInputsModule
  ],
  exports: [MaxisChartComponent]
})
export class MaxisChartsModule { }
